// test baseURL: https://testapigateway.avajang.com
// main baseURL: https://apigateway.avajang.com

// export const URLS_CONSTANTS = {
//   baseURL: "https://apigateway.avajang.com",
//   authority: process.env.VUE_APP_AUTHORITY,
//   clientId: process.env.VUE_APP_CLIENT_ID,
//   redirect_uri: process.env.VUE_APP_REDIRECT_URI,
//   post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
//   redirected_uri: process.env.VUE_APP_REDIRECTED_URI,
//   website_api: process.env.VUE_APP_WEBSITE_API,
//   assets: process.env.VUE_APP_ASSETS,
// };

// export const URLS_CONSTANTS = {
//   baseURL: "https://testapigateway.avajang.com",
//   authority: "https://auth.avajang.com",
//   clientId: "avajang_console_client_test",
//   redirect_uri: "https://testconsole.avajang.com/static/callback2.html",
//   post_logout_redirect_uri: "https://testconsole.avajang.com/",
//   redirected_uri: "https://testconsole.avajang.com/",
//   website_api: "https://testsite.avajang.com",
//   assets: "https://asset.avajang.com/",
// };

// export const URLS_CONSTANTS = {
//   baseURL: "http://localhost:51000",
//   authority: "https://auth.avajang.com",
//   clientId: "avajang_console_client_test",
//   redirect_uri: "http://localhost:8080/static/callback2.html",
//   post_logout_redirect_uri: "http://localhost:8080/",
//   redirected_uri: "http://localhost:8080/",
//   website_api: "https://testsite.avajang.com",
//   assets: "https://asset.avajang.com/",
// };

export const URLS_CONSTANTS = {
  baseURL: process.env.VUE_APP_BASE_URL,
  authority: process.env.VUE_APP_AUTHORITY,
  clientId: process.env.VUE_APP_CLIENT_ID,
  redirect_uri: process.env.VUE_APP_REDIRECT_URI,
  post_logout_redirect_uri: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
  redirected_uri: process.env.VUE_APP_REDIRECTED_URI,
  website_api: process.env.VUE_APP_WEBSITE_API,
  assets: process.env.VUE_APP_ASSETS,
};
